module.exports = __webpack_public_path__ + "img/desc3.19b4c0e2.jpg";